import React, { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import AIheader from '../RentAI/AIheader';
import Footer from '../../Component/Footer/Footer';
import GetStartedFlow from '../../Component/PreOnboarding/GetStartedFlow';
import '../../Component/PreOnboarding/PreOnboarding.css';

// Pre-onboarding flow page. Uses the site-standard header (AIheader) and Footer;
// the body is the ported "choose your path" + multi-step pre-boarding form.
const PreOnboarding = () => {
  // Client-side navigation preserves scroll position; reset to the top so the
  // user lands on the header/intro rather than mid-page. useLayoutEffect runs
  // before the browser paints, so the page renders at the top from the start.
  // behavior: 'instant' overrides the global `html { scroll-behavior: smooth }`
  // (Header.css), which otherwise animates this reset as a visible scroll-up.
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <>
    <Helmet>
      <title>Get Started — RentDirect by Rentid</title>
      <meta
        name="description"
        content="Start your RentDirect onboarding. Launch your fleet now or begin pre-boarding with a Rentid expert."
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>

    <AIheader />

    <div className="pre-onboarding">
      <GetStartedFlow />
    </div>

    <Footer />
    </>
  );
};

export default PreOnboarding;
